import { Injectable } from "@angular/core";
import { Observable, from } from "rxjs";
import { switchMap } from 'rxjs/operators';
import { IHttpRequest } from "./IHttpRequest ";
import { AuthWrapper } from "./authWrapper";
import { LocalAxiosHttpRequest } from "./localAxiosHttpRequest";
import { ExternalAxiosHttpRequest } from "./externalAxiosHttpRequest";

@Injectable({
  providedIn: "root",
})
export class AxiosHttpRequest implements IHttpRequest {
 
  constructor(
    private authWrapper: AuthWrapper
    , private ssoHttpRequest: ExternalAxiosHttpRequest
    , private localHttpRequest: LocalAxiosHttpRequest
  ) {
  }

  private async resolveHttpRequest(): Promise<IHttpRequest> {
    const mode = await this.authWrapper.getMode();

    switch (mode) {
      case 'sso':
        return this.ssoHttpRequest;

      case 'legacy':
        return this.localHttpRequest;

      default:
        throw new Error(
          'Authentication mode has not been initialized'
        );
    }
  }

  public get<T = any>(
    url: string,
    params?: any
  ): Observable<T> {
    return from(this.resolveHttpRequest()).pipe(
      switchMap(request =>
        request.get<T>(url, params)
      )
    );
  }

  public post<T = any>(
    url: string,
    body: any
  ): Observable<T> {
    return from(this.resolveHttpRequest()).pipe(
      switchMap(request =>
        request.post<T>(url, body)
      )
    );
  }

  public postWithHeaderParams<T = any>(
    url: string,
    body: any,
    params: any
  ): Observable<T> {
    return from(this.resolveHttpRequest()).pipe(
      switchMap(request =>
        request.postWithHeaderParams<T>(
          url,
          body,
          params
        )
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/infra/axioshttprequest.ts